import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getSubscriptionsList(actions) {

  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-subscriptions?page=" + actions.page
        : apiUrl + "/opa-subscriptions" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "LIST_SUBSCRIPTION_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_SUBSCRIPTION_RESPONSE_GET", value: error });
  }
}

function* getSubscription(actions) {
  let uuid = actions.idUser ? actions.idUser : getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-subscription/"
        : apiUrl + "/opa-subscription/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "SUBSCRIPTION_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "SUBSCRIPTION_RESPONSE_GET", value: error });
  }
}

function* resetSubscription() {
  yield put({ type: "SUBSCRIPTION_RESPONSE_RESET" });
}

function* createSubscription(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-subscription";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.status == 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "SUBSCRIPTION_RESPONSE_ADD", value: { ...response, responseStatus } });
    return response;
  } catch (error) {
    yield put({ type: "SUBSCRIPTION_RESPONSE_ADD", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

function* editSubscription(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-subscription/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.status == 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "SUBSCRIPTION_RESPONSE_EDIT", value: { ...response, responseStatus } });
    return response;
  } catch (error) {
    yield put({ type: "SUBSCRIPTION_RESPONSE_EDIT", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

function* deleteSubscription(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers
    };

    let url = apiUrl + "/opa-subscription/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);
    if (response.status === 204 || response.status === 200) {
      yield put({
        type: "SUBSCRIPTION_RESPONSE_DELETE",
        payload: { status: response.status, responseStatus: "success" },
      });
    } else {
      yield put({
        type: "SUBSCRIPTION_RESPONSE_DELETE",
        payload: response,
      });
    }
  } catch (error) {
    yield put({
      type: "SUBSCRIPTION_RESPONSE_DELETE",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}


export function* getSagaSubscriptionsList() {
  yield takeEvery("GET_LIST_SUBSCRIPTIONS", getSubscriptionsList);
}

export function* getSagaSubscription() {
  yield takeEvery("GET_SUBSCRIPTION", getSubscription);
}

export function* resetSagaSubscription() {
  yield takeEvery("RESET_SUBSCRIPTION", resetSubscription);
}

export function* createSagaSubscription() {
  yield takeEvery("ADD_SUBSCRIPTION", createSubscription);
}

export function* editSagaSubscription() {
  yield takeEvery("EDIT_SUBSCRIPTION", editSubscription);
}

export function* deleteSagaSubscription() {
  yield takeEvery("DELETE_SUBSCRIPTION", deleteSubscription);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
